export enum CalendarEventVisibility {
    Default,
    Public,
    Private,
    Confidential,
}
